import React from "react";
import { shallowEqual } from "react-redux";
import BasketItemRow from "../items/BasketItemRow";
import { removeFinancePackExtra, removeFinancePackServiceProducts } from "../../../../../redux/actions/BasketActions";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import type { PackType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import { getSelectedFinancePackEquipmentSelector } from "../../../../../utils/selectorUtils";
import BasketFinancePackEquipment from "./BasketFinancePackEquipment";
import { trackBasketRemoveExtra } from "../../../../../utils/tracking";
import { NavStep } from "../../../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

type BasketFinancePackExtrasPropType = {
    pack: PackType;
};

const BasketFinancePackExtras = (props: BasketFinancePackExtrasPropType): JSX.Element => {
    const { pack } = props;
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const financePackExtras = useBnbSelector((state) => state.basket.financePackExtras);
    const financePackServiceProducts = useBnbSelector((state) => state.basket.financePackServiceProducts);

    const basketEquipment = useBnbSelector(getSelectedFinancePackEquipmentSelector(pack), shallowEqual);

    return (
        <>
            {financeOption === "monthly" &&
                financePackExtras
                    // Only show the financePackExtras that are actually in the pack.
                    .filter((packExtra) => pack.equipment.find((eq) => eq.id === packExtra.id))
                    .map((extra) => (
                        <BasketItemRow
                            key={extra.id}
                            name={`+ ${extra.name}`}
                            price={extra.price}
                            removeItem={() => {
                                trackBasketRemoveExtra(NavStep.Customize);
                                dispatch(removeFinancePackExtra(extra, true));
                            }}
                        />
                    ))}
            {financeOption === "monthly" &&
                financePackServiceProducts
                    // Only show the financePackExtras that are actually in the pack.
                    .filter((packServiceProduct) =>
                        pack.serviceProducts.find((serviceProduct) => serviceProduct.id === packServiceProduct.id),
                    )
                    .map((serviceProduct) => (
                        <BasketItemRow
                            key={serviceProduct.id}
                            name={`+ ${serviceProduct.name}`}
                            price={serviceProduct.price}
                            removeItem={() => {
                                trackBasketRemoveExtra(NavStep.Customize);
                                dispatch(removeFinancePackServiceProducts(serviceProduct, true));
                            }}
                        />
                    ))}
            {financeOption === "cash" &&
                [...basketEquipment.standard, ...basketEquipment.optional].map((financePackExtra) => (
                    <BasketFinancePackEquipment key={financePackExtra.id} pack={pack} equipment={financePackExtra} />
                ))}
        </>
    );
};

export default BasketFinancePackExtras;
